import { AdditionalInformationValueType } from '@bpos';
import { BetDetailType } from '@bpos/common/bet-placement';
import { Bet, Pick } from '@bpos/v2/bet-placement';

import { IBetslipState } from '../../../../../base/store/state';
import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { IBoostedPrice } from '../../../../../core/picks/pick-models';
import { ISlipPick } from '../../../../bet-generation/models';
import { BasePickRequestMapper } from './base-pick-request-mapper';
import { EmptyStringWithSignature, mapTeaserBetOptionName, mapTextValueData } from './text-value-helper';

export class V1PickRequestMapper extends BasePickRequestMapper {
    mapBetDetails(
        slipPick: ISlipPick<BetslipV1Pick>,
        bet: Bet,
        _boostedPrice: IBoostedPrice | undefined,
        state?: IBetslipState,
        options?: { isTeaser?: boolean; isInGroup?: boolean },
    ): void {
        bet.picks = [{ id: slipPick.priceIds[0].toString(10) }] as Pick[];
        const pick = slipPick.pick;

        // Sport
        bet.betDetails.push({
            id: pick.sport.id.toString(10),
            betDetailType: BetDetailType.Sport,
            additionalInformation: { informationItems: [] },
            ...mapTextValueData(pick, 'sportName'),
        });

        // Region
        bet.betDetails.push({
            id: pick.region.id.toString(10),
            betDetailType: BetDetailType.Region,
            additionalInformation: { informationItems: [] },
            ...mapTextValueData(pick, 'regionName'),
        });

        // League
        bet.betDetails.push({
            id: pick.league.id.toString(10),
            betDetailType: BetDetailType.Competition,
            additionalInformation: { informationItems: [] },
            ...mapTextValueData(pick, 'leagueName'),
        });

        // Event
        bet.betDetails.push({
            id: pick.event.id,
            betDetailType: BetDetailType.Fixture,
            additionalInformation: { informationItems: [] },
            ...mapTextValueData(pick, 'eventName'),
        });

        bet.additionalInformation.informationItems.push({
            key: 'fixtureStartTime',
            value: pick.event.eventDate.toISOString(),
            valueType: AdditionalInformationValueType.DateTime,
        });

        // Market
        bet.betDetails.push({
            id: pick.market.id.toString(10),
            betDetailType: BetDetailType.Market,
            additionalInformation: { informationItems: [] },
            ...mapTextValueData(pick, 'marketName'),
        });

        // Option
        const textValue = {
            value: options?.isTeaser ? mapTeaserBetOptionName(pick, pick.option.name.name, state) : pick.option.name.name,
            sign: pick.option.name.signature,
        };
        let altTextValue = EmptyStringWithSignature;
        if (pick.option.name.nameAlternate && pick.option.name.signatureAlternate) {
            altTextValue = {
                value: options?.isTeaser ? mapTeaserBetOptionName(pick, pick.option.name.nameAlternate, state) : pick.option.name.nameAlternate,
                sign: pick.option.name.signatureAlternate,
            };
        }
        bet.betDetails.push({
            id: pick.option.id.toString(10),
            betDetailType: BetDetailType.Option,
            textValue,
            altTextValue,
            additionalInformation: { informationItems: [] },
        });
    }
}
